import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Directive, Component, ViewEncapsulation, ContentChildren, Input, NgModule } from '@angular/core';
import * as i2 from '@angular/material/checkbox';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';

class XpoCheckboxGroupHorizontal {
}
XpoCheckboxGroupHorizontal.ɵfac = function XpoCheckboxGroupHorizontal_Factory(t) { return new (t || XpoCheckboxGroupHorizontal)(); };
XpoCheckboxGroupHorizontal.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoCheckboxGroupHorizontal, selectors: [["", "xpo-checkbox-group-horizontal", ""], ["", "xpoCheckboxGroupHorizontal", ""]], hostAttrs: [1, "xpo-CheckboxGroupHorizontal--wrap"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoCheckboxGroupHorizontal, [{
        type: Directive,
        args: [{
                selector: '[xpo-checkbox-group-horizontal], [xpoCheckboxGroupHorizontal] ',
                host: {
                    class: 'xpo-CheckboxGroupHorizontal--wrap',
                },
            }]
    }], null, null); })();

function XpoCheckboxGroupComponent_mat_checkbox_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-checkbox", 3);
    i0.ɵɵlistener("change", function XpoCheckboxGroupComponent_mat_checkbox_2_Template_mat_checkbox_change_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return ctx_r1.onSelectAllChange($event); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("indeterminate", ctx_r0.isIndeterminate)("checked", ctx_r0.isChecked);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.selectAllLabel, " ");
} }
const _c0 = [[["mat-label"]], "*"];
const _c1 = ["mat-label", "*"];
class XpoCheckboxGroupComponent {
    constructor() {
        this.selectAllLabel = '';
        this.isChecked = false;
        this.isIndeterminate = false;
    }
    onSelectAllChange(event) {
        this.isChecked = event.checked;
        this.isIndeterminate = false;
        this.childrenCheckboxes.forEach((child) => {
            child.checked = event.checked;
        });
    }
    ngAfterContentInit() {
        // initialize state for main checkbox group
        this.isIndeterminate = this.isSelectAllIndeterminate();
        this.isChecked = this.isSelectAllChecked();
        // subscribe state change for each checkbox in the group
        this.childrenCheckboxes.forEach((checkbox) => {
            checkbox.change.subscribe(() => {
                // set main checkbox group state
                this.isIndeterminate = this.isSelectAllIndeterminate();
                this.isChecked = this.isSelectAllChecked();
            });
        });
    }
    isSelectAllIndeterminate() {
        return (this.childrenCheckboxes.some((child) => child.checked) && this.childrenCheckboxes.some((child) => !child.checked));
    }
    isSelectAllChecked() {
        return this.childrenCheckboxes.toArray().every((child) => child.checked);
    }
}
XpoCheckboxGroupComponent.ɵfac = function XpoCheckboxGroupComponent_Factory(t) { return new (t || XpoCheckboxGroupComponent)(); };
XpoCheckboxGroupComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoCheckboxGroupComponent, selectors: [["xpo-checkbox-group"]], contentQueries: function XpoCheckboxGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, MatCheckbox, 4);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childrenCheckboxes = _t);
    } }, hostAttrs: [1, "xpo-CheckboxGroupHost"], inputs: { selectAllLabel: "selectAllLabel" }, ngContentSelectors: _c1, decls: 5, vars: 3, consts: [[1, "xpo-CheckboxGroup"], ["class", "xpo-CheckboxGroup-selectAll", 3, "indeterminate", "checked", "change", 4, "ngIf"], [1, "xpo-CheckboxGroup-childrenWrapper"], [1, "xpo-CheckboxGroup-selectAll", 3, "indeterminate", "checked", "change"]], template: function XpoCheckboxGroupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0);
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵprojection(1);
        i0.ɵɵtemplate(2, XpoCheckboxGroupComponent_mat_checkbox_2_Template, 2, 3, "mat-checkbox", 1);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵprojection(4, 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.selectAllLabel !== "");
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("xpo-CheckboxGroup-childrenWrapper--noSelectAll", ctx.selectAllLabel === "");
    } }, directives: [i1.NgIf, i2.MatCheckbox], styles: [".flex--stretch{flex:1}.xpo-CheckboxGroupHost .xpo-CheckboxGroup mat-label{color:#6f6f6f;display:flex;font-size:.875rem;font-style:normal;font-weight:400;letter-spacing:.1px;line-height:normal;margin-left:14px;text-align:left}.xpo-CheckboxGroupHost .xpo-CheckboxGroup-childrenWrapper{display:flex;flex-direction:column;margin-left:20px}.xpo-CheckboxGroupHost .xpo-CheckboxGroup-childrenWrapper--noSelectAll{margin-left:4px}.xpo-CheckboxGroupHost.xpo-CheckboxGroupHorizontal--wrap .xpo-CheckboxGroup-childrenWrapper{display:inline}\n"], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoCheckboxGroupComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-checkbox-group',
                templateUrl: './checkbox-group.component.html',
                styleUrls: ['./checkbox-group.component.scss'],
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-CheckboxGroupHost' },
            }]
    }], null, { childrenCheckboxes: [{
            type: ContentChildren,
            args: [MatCheckbox]
        }], selectAllLabel: [{
            type: Input
        }] }); })();

class XpoCheckboxModule {
}
XpoCheckboxModule.ɵfac = function XpoCheckboxModule_Factory(t) { return new (t || XpoCheckboxModule)(); };
XpoCheckboxModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoCheckboxModule });
XpoCheckboxModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, MatCheckboxModule, MatFormFieldModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoCheckboxModule, [{
        type: NgModule,
        args: [{
                declarations: [XpoCheckboxGroupComponent, XpoCheckboxGroupHorizontal],
                imports: [CommonModule, MatCheckboxModule, MatFormFieldModule],
                exports: [XpoCheckboxGroupComponent, XpoCheckboxGroupHorizontal],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoCheckboxModule, { declarations: [XpoCheckboxGroupComponent, XpoCheckboxGroupHorizontal], imports: [CommonModule, MatCheckboxModule, MatFormFieldModule], exports: [XpoCheckboxGroupComponent, XpoCheckboxGroupHorizontal] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoCheckboxGroupComponent, XpoCheckboxGroupHorizontal, XpoCheckboxModule };
